<ng-container *ngIf="showGraph">
  <h3 class="v4-color-white mt-2">
    {{ "Rating" | translator }}
  </h3>
  <span class="line"></span>
</ng-container>
<div class="row" *ngIf="showGraph">
  <div class="col-md-4 about-card-new my-2">
    <p-inputNumber
      [(ngModel)]="ratingLimit"
      [min]="5"
      (ngModelChange)="ngOnInit()"
      [inputStyle]="{ 'text-align': 'right', width: '100%' }"
      [step]="10"
      [showButtons]="true"
      buttonLayout="horizontal"
      incrementButtonIcon="pi pi-plus"
      decrementButtonIcon="pi pi-minus"
    ></p-inputNumber>
  </div>
  <div class="col-md-8 about-card-new my-2">
    <p-dropdown
      [filter]="true"
      filterBy="type"
      (onChange)="ngOnInit()"
      [(ngModel)]="selectedType"
      placeholder="{{ 'Select type' | translator }}"
      [options]="trainingType"
      styleClass="w-100"
      optionLabel="type"
      optionValue="id"
    >
    </p-dropdown>
  </div>
<!-- 
    <div class="col-md-4 about-card-new">
        <p-inputNumber
            [(ngModel)]="ratingLimit"
            [min]="5"
            (ngModelChange)="ngOnInit()"
            [inputStyle]="{'text-align': 'right','width':'100%'}"
            [step]="10"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
        ></p-inputNumber>
    </div>
    <div class="col-md-8 about-card-new">
        <p-dropdown [filter]="true" filterBy="type"
            (onChange)="ngOnInit()" [(ngModel)]="selectedType" placeholder="{{ 'Select type' | translator }}"
            [options]="trainingType" styleClass="w-100" optionLabel="type" optionValue="id">
        </p-dropdown>
    </div>
 mateen-v4-angularudate -->
</div>
<div *ngIf="isSkelition" class="d-flex justify-content-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<div *ngIf="!isSkelition && showGraph" class="v4-graph-bg">
  <p-chart
    type="line"
    [data]="graphData"
    [options]="lineChartOptions"
    height="200"
  ></p-chart>
</div>
